<template>
  <div :class="{'has-logo':showLogo}" :style="{ backgroundColor: settings.sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar :class="settings.sideTheme" wrap-class="scrollbar-wrapper">
      <el-menu
        :active-text-color="settings.theme"
        :background-color="settings.sideTheme === 'theme-dark' ? variables.menuBackground : variables.menuLightBackground"
        :collapse="isCollapse"
        :collapse-transition="false"
        :default-active="activeMenu"
        :open-keys="openKeys"
        :text-color="settings.sideTheme === 'theme-dark' ? variables.menuColor : variables.menuLightColor"
        :unique-opened="true"
        mode="vertical"
        router
        @open="handleOpen"
      >
        <sidebar-item
          v-for="(route, index) in sidebarRouters"
          :key="route.uniqueKey"
          :base-path="route.path"
          :item="route"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
  import { mapGetters, mapState } from "vuex"
  import Logo from "./Logo"
  import SidebarItem from "./SidebarItem"
  import variables from "@/assets/styles/variables.scss"


  export default {
    components: { SidebarItem, Logo },
    data() {
      // 本地存储展开key，不和computed重名，不调用不存在的Vuex mutation
      return {
        localOpenKeys: []
      }
    },
    methods: {
      handleOpen(key) {
        // 三级iframe禁止手动展开父菜单
        if (this.$route.meta.isIframePage && this.$route.meta.menuDepth === 3) {
          return
        }
        this.localOpenKeys = [key]
      },
      // 递归查找父菜单key
      getParentKeyList(targetPath) {
        const keys = []
        const loopFind = (routes) => {
          for (const r of routes) {
            if (r.path === targetPath) return true
            if (r.children && r.children.length) {
              if (loopFind(r.children)) {
                keys.push(r.uniqueKey)
                return true
              }
            }
          }
          return false
        }
        loopFind(this.sidebarRouters)
        return keys
      }
    },
    computed: {
      ...mapState(["settings"]),
      ...mapGetters(["sidebarRouters", "sidebar"]),
      activeMenu() {
        const route = this.$route
        const { meta, path } = route
        if (meta.activeMenu) {
          return meta.activeMenu
        }
        return path
      },
      showLogo() {
        return this.$store.state.settings.sidebarLogo
      },
      variables() {
        return variables
      },
      isCollapse() {
        return !this.sidebar.opened
      },
      openKeys() {
        const route = this.$route
        // 三级iframe自动清空展开列表，不展开一二层目录
        if (route.meta.isIframePage && route.meta.menuDepth === 3) {
          return []
        }
        return this.localOpenKeys.length ? this.localOpenKeys : this.getParentKeyList(route.path)
      }
    }
  }
</script>
<style>
  /* 覆盖 Element UI 子菜单容器内联 padding-left，确保统一左对齐 */
  .el-menu--inline {
    padding-left: 0 !important;
  }
  /* 所有级别菜单项和子菜单标题 - 统一强制左对齐 */
  .el-menu-item,
  .el-submenu__title,
  .el-submenu .el-menu-item,
  .el-submenu .el-submenu__title,
  .el-submenu .el-submenu .el-menu-item,
  .el-submenu .el-submenu .el-submenu__title {
    padding-left: 0 !important;
  }
  /* 图标容器统一占位，保证有/无图标的菜单文字在同一水平线 */
  .el-menu-item i.menu-icon-wrap,
  .el-submenu__title i.menu-icon-wrap {
    display: inline-block;
    width: 22px;
    text-align: center;
    margin-right: 6px;
    vertical-align: middle;
    font-size: 0;
  }
  /* 移除 svg-icon 在菜单项里的全局 16px 右间距，避免额外缩进 */
  .el-menu-item i.menu-icon-wrap .svg-icon,
  .el-submenu__title i.menu-icon-wrap .svg-icon {
    margin-right: 0;
    vertical-align: middle;
  }
  /* Element UI 图标在 menu-icon-wrap 内需要恢复字号，否则被 font-size:0 隐藏 */
  .el-menu-item i.menu-icon-wrap[class*="el-icon-"],
  .el-submenu__title i.menu-icon-wrap[class*="el-icon-"] {
    font-size: 16px;
  }
  /* 恢复 Element UI 箭头图标默认 line-height，避免被其他样式污染导致错位 */
  .el-submenu__title > .el-submenu__icon-arrow {
    line-height: 1 !important;
  }
</style>
